import EnableDuoButton from 'features/admin-profile/two-factor-providers/duo-security/EnableDuoButton';
import EnableTotpAuthenticator from 'features/admin-profile/two-factor-providers/totp/EnableTotpAuthenticator';
import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import CardHeader from 'reactstrap/lib/CardHeader';

interface TwoFactorData {
	twoFactorRequired: boolean;
	duoSecurityEnabled: boolean;
	duoSecurityForLdapOnly: boolean;
	isLdapUser: boolean;
	shouldShowRegistrationPage: boolean;
}

const redirectToAdmin = () => window.location.replace('/');
const redirectToLicenseRegistration = () => window.location.replace('/register-installation');

/**
 * Login Two Factor Authenticator Setup screen, shown after a user logs in but before they visit the CMS
 */
export default function LoginTwoFactorSetup() {
	const [totpSetupActive, setTotpSetupActive] = useState(false);
	const [duoSetupActive, setDuoSetupActive] = useState(false);
	const is2faUiActive = totpSetupActive || duoSetupActive;

	// Load two-factor data from the page javascript
	const twoFactorData: TwoFactorData = (window as any).__ROC_TWO_FACTOR_DATA__;
	const { twoFactorRequired, duoSecurityEnabled, duoSecurityForLdapOnly, isLdapUser, shouldShowRegistrationPage } =
		twoFactorData;

	const hideDuo = !duoSecurityEnabled || (duoSecurityForLdapOnly && !isLdapUser);

	return (
		<>
			<div className="login-2fa">
				<Card>
					<CardHeader>
						<strong>
							Two Factor Authentication Setup {twoFactorRequired ? '(Required)' : '(Optional)'}
						</strong>
					</CardHeader>
					<CardBody>
						{!hideDuo && (!is2faUiActive || duoSetupActive) ? (
							<EnableDuoButton setActivated={setDuoSetupActive} />
						) : null}{' '}
						{!is2faUiActive || totpSetupActive ? (
							<EnableTotpAuthenticator
								setActivated={setTotpSetupActive}
								onFinished={() => {
									shouldShowRegistrationPage ? redirectToLicenseRegistration() : redirectToAdmin();
								}}
							/>
						) : null}
						{twoFactorRequired ? null : (
							<>
								<Button
									data-testid="skip-2fa-setup"
									onClick={() => {
										shouldShowRegistrationPage
											? redirectToLicenseRegistration()
											: redirectToAdmin();
									}}
								>
									Skip
								</Button>{' '}
							</>
						)}
					</CardBody>
				</Card>
				<br />
			</div>
		</>
	);
}
